"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
exports.createOsmosysResource = (name) => {
    return graphql_tag_1.default `
    mutation createResourceOfWorkflow(
      $data: OsmosysResourceCreateInput!
    ) {
      createResourceOf${name}(data: $data) {
        id
        createdAt
        resource {
          id
          name
          slug
          resourceType
          workspace {
            id
          }
        }
      }
    }
  `;
};
exports.listOsmosysResources = (name) => {
    return graphql_tag_1.default `
    query listResources(
      $skip: Int,
      $take: Int
    ) {
      list${name}s(
        skip: $skip,
        take: $take
      ) {
        count
        edges {
          id
          createdAt
          resource {
            id
            name
            slug
            resourceType
            workspace {
              id
            }
          }
        }
      }
    }
  `;
};
exports.getOsmosysResource = (name) => {
    return graphql_tag_1.default `
    query getResource(
      $id: ID!
    ) {
      get${name}(id: $id) {
        id
        createdAt
        resource {
          id
          name
          slug
          resourceType
          workspace {
            id
          }
        }
      }
    }
  `;
};
//# sourceMappingURL=osmosysResources.js.map